/*
* @Author: abhi
* @Date:   2024-04-20 19:56:55
* @Last Modified by:   abhishek714
* @Last Modified time: 2025-06-18 14:48:08
*/
import { MAIL_FORMAT, ucwords } from './common';

export const Validation = (data, validate_fields) => {
	let errors = {};

	if (Array.isArray(validate_fields) && validate_fields.length > 0) {
		validate_fields.forEach((field) => {
			const fieldLabel = ucwords(field.replace(/_/g, " "));

			if (field === 'email') {
				if (!data[field]) {
					errors[field] = `${fieldLabel} is required.`;
				} else if (!MAIL_FORMAT.test(data[field])) {
					errors[field] = `${fieldLabel} is invalid.`;
				}
			} else if (field === 'confirm_password') {
				if (!data[field]) {
					errors[field] = `${fieldLabel} is required.`;
				} else if (data[field] !== data['password']) {
					errors[field] = 'Please enter the same value again.';
				}
			} else if(field === 'assigned_to_id'){
				if (!data[field]) {
					errors[field] = `This field is required.`;
				}
			} else {
				if (!data[field]) {
					errors[field] = `${fieldLabel} is required.`;
				}
			}
		});
	}

	return errors;
};